import type { TunnelSelectProps } from "@hightouch/formkit";
import { Controller } from "react-hook-form";
import { TunnelSelect } from "src/components/tunnel-select";
import type { SourceTunnel } from "src/utils/sources";
import type { SharedProps } from ".";

export const FKTunnelSelect = ({
  name,
  isDisabled,
  showHeading,
}: TunnelSelectProps & SharedProps) => (
  <Controller
    name={name}
    render={({ field }) => (
      <TunnelSelect
        isDisabled={isDisabled}
        onChange={(tunnel: SourceTunnel | undefined) =>
          field.onChange(tunnel?.id ?? null)
        }
        value={field.value ? { id: field.value } : undefined}
        showHeading={showHeading}
      />
    )}
  />
);
